import { inArray } from "../helpers";

export default class Message {
    constructor(messageBoxName, state) {
        const messageBoxPrefix = "data-message-box";
        this.mainSelector = `${messageBoxPrefix}-${messageBoxName}`;
        if (!inArray(state, Message.getStates())) {
            throw new Error("State is no exists!");
        }
        this.state = state;
        this.messageBox = document.querySelector(`[${this.mainSelector}]`);
        this.outputText = this.messageBox ? this.messageBox.querySelector(`[${this.mainSelector}-text]`) : null;
        this.closeMessageBox = this.messageBox ? this.messageBox.querySelector(`[${this.mainSelector}-close]`) : null;

        if (this.closeMessageBox) {
            this.closeMessageBox.addEventListener("click", (evt) => this.hideMessage(evt));
        }
    }

    clearStates() {
        Message.getStates().forEach((state) => {
            this.messageBox.classList.remove(state);
        });
    }

    display(message) {
        if (!this.messageBox || !this.outputText) {
            return;
        }

        // Clear existing classes and add appropriate one
        this.clearStates();
        this.messageBox.classList.add(this.state);

        // Set message text
        this.outputText.innerHTML = "";
        this.outputText.innerHTML = message;

        // Automatically hide message after 3 seconds
        setTimeout(() => this.hideMessage(), 3000);
    }

    hideMessage(evt) {
        if (evt) {
            evt.preventDefault();
        }
        if (this.messageBox) {
            this.clearStates();
        }
    }

    static getStates() {
        return ["success", "error"];
    }

    static displayMessage(message, messageBoxName, state) {
        const messageObject = new Message(messageBoxName, state);
        messageObject.display(message);
    }
}
